var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMultipleCount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 25.9",
    style: {
      enableBackground: "new 0 0 36 25.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:0.7802;stroke-linecap:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.3,14.1h23.3c1.3,0,2.3,1,2.3,2.3v5c0,0.4-0.3,0.8-0.8,0.8H1.8c-0.4,0-0.8-0.3-0.8-0.8v-5 C1.1,15.1,2.1,14.1,3.3,14.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.2,8.8c0.6-1,1.6-1.6,2.7-1.6h12.4c1.2,0,2.2,0.7,2.8,1.7l2.5,5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.8,24.1c0,0.7-0.5,1.2-1.2,1.2h-3.8c-0.6,0-1.2-0.5-1.2-1.2v-1.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.3,24.1c0,0.7-0.5,1.2-1.2,1.2H3.4c-0.6,0-1.2-0.5-1.2-1.2v-1.9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 7,
    cy: 18.1,
    rx: 1.8,
    ry: 1.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 23.1,
    cy: 18.1,
    rx: 1.8,
    ry: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.3,5.7c0.6-1,1.6-1.6,2.7-1.6h12.4c1.2,0,2.2,0.7,2.8,1.7l2.6,5.2c1.2,0,2.2,1,2.2,2.3v5 c0,0.4-0.3,0.8-0.7,0.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.3,2.6c0.6-1,1.6-1.6,2.7-1.6h12.4c1.2,0,2.2,0.7,2.8,1.7l2.6,5.2c1.2,0,2.2,1,2.2,2.3v5 c0,0.4-0.3,0.8-0.7,0.8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleCount);
export default __webpack_public_path__ + "static/media/multiple-count.c3da76fbb527674b746f210f4eeff0c7.svg";
export { ForwardRef as ReactComponent };